/*
==========================================
スタッフが選ぶとっておきのワイン（sections/c-gift-staff-selection.liquid）
コメントの「もっと読む」折りたたみ

- 折りたたみ時の高さ制限・透過は CSS（PC/SP の修飾クラス × メディアクエリ）で行う
- JS は本文が制限の高さを超えているかを判定し、超えている場合のみ is-truncated を付与してリンクを表示する
- テーマエディタの再描画や Swiper のスライド移動にも追従させるためカスタム要素で実装
- 1ページに同セクションが複数ある場合も子要素の解析後に初期化されるよう、defer で読み込む
==========================================
*/
if (!customElements.get('c-staff-comment-readmore')) {
  customElements.define('c-staff-comment-readmore', class extends HTMLElement {
    connectedCallback() {
      this.body = this.querySelector('.c-staff-selection-comment__readmore-body');
      this.inner = this.querySelector('.c-staff-selection-comment__readmore-inner');
      this.button = this.querySelector('.c-staff-selection-comment__readmore-btn');
      if (!this.body || !this.inner || !this.button) return;

      if (!this.isInitialized) {
        this.isInitialized = true;
        this.button.addEventListener('click', () => this.toggle());
        // 隠れている部分のリンクにキーボードでフォーカスした場合は展開する
        this.body.addEventListener('focusin', () => {
          if (this.classList.contains('is-truncated') && !this.classList.contains('is-expanded')) {
            this.toggle();
          }
        });
        this.resizeObserver = new ResizeObserver(() => this.update());
      }
      // inner: 本文の高さ変化（画像・フォント読込、幅変更）、body: ブレイクポイントによる高さ制限の切替
      this.resizeObserver.observe(this.inner);
      this.resizeObserver.observe(this.body);
      this.update();
    }

    disconnectedCallback() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
      }
    }

    toggle() {
      const isExpanded = this.classList.toggle('is-expanded');
      this.button.setAttribute('aria-expanded', isExpanded);
      this.body.scrollTop = 0;
      this.update();
    }

    update() {
      // 展開中は高さ制限が外れて判定できないため、折りたたみ時の状態を維持する
      if (this.classList.contains('is-expanded')) return;
      this.classList.toggle('is-truncated', this.inner.offsetHeight > this.body.clientHeight + 1);
    }
  });
}
